import styled from 'styled-components';

export const Main = styled.div`
  font-family: 'Playfair Display', sans-serif;
  // margin-bottom: 100px;
  display: flex;
  height: 600px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: url(${({ theme }) => theme.font1});
`;

export const Section = styled.section`
  display: flex;
  justify-content: space-around;
  align-items: center;
  @media (max-width: 900px) {
    flex-direction: column;
  
  gap: 5rem;
  text-align: center; /* Centraliza o texto */
`;

export const TextDiv = styled.div`
  display: flex;

  text-align: center; /* Centraliza o texto */
  div div {
    display: flex;
    flex-direction: column;
    text-align: left;
    width: 330px;
    gap: 1rem; /* Diminui o espaçamento entre as linhas */
  }
  h1 {
    font-size: 48px;
    color: #5a3e2b;
    font-family: 'playfairDisplayExtraBold', sans-serif;
  }

  a {
    font-family: 'Roboto Bold', sans-serif;
    font-size: 18px;
    color: #a83f2b;
    text-decoration: none;
    margin-top: 1rem;
  }
  p {
    font-family: 'roboto Medium', sans-serif;
    font-size: 16px;
    color: #5a3e2b;
    @media (max-width: 900px) {
      font-size: 12px;
    }
  }
`;

export const CarrosselContainer = styled.div`
  position: relative;
  justify-content: center;
  display: flex;
  width: 820px;
  overflow: hidden;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

export const CarrosselInner = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  gap: 1rem;
  @media (max-width: 900px) {
    width: 350px;
  }
  width: 500px;
`;

export const CarrosselItem = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  // align-items: center;
  min-width: 100%;
  gap: 15px;
  padding: 10px;
  width: 350px;
  border: 1px solid rgba(0, 0, 0, 0.75);
  border-radius: 3px;
  @media (max-width: 900px) {
    // gap: 25px;
    padding: 10px;
  }
  div {
    width: 100%;
    display: flex;

    justify-content: flex-start;
    div {
      display: flex;
      // align-items: center;
      width: 98%;
      justify-content: space-between;
      @media (max-width: 900px) {
        width: 98%;
      }
    }
  }
  img {
    border-right: 1px solid rgba(0, 0, 0, 0.75);
  }

  h3 {
    font-family: 'roboto Medium', sans-serif;
    font-size: 16px;
  }
  p {
    font-family: 'roboto Medium', sans-serif;
    font-size: 16px;
    color: #543530;
    @media (max-width: 900px) {
      font-size: 12px;
    }
  }
  .azul {
    h3 {
      font-family: 'roboto Medium', sans-serif;
      font-size: 16px;
      color: #6f7c8f;
    }
  }
  .vermelho {
    h3 {
      font-family: 'roboto Medium', sans-serif;
      font-size: 16px;
      color: #a04330;
    }
  }
  .marrom {
    h3 {
      font-family: 'roboto Medium', sans-serif;
      font-size: 16px;
      color: #543530;
    }
  }
  .amarelo {
    h3 {
      font-family: 'roboto Medium', sans-serif;
      font-size: 16px;
      color: #e7a044;
    }
  }
`;

export const CarrosselText = styled.div`
  display: flex;
  // gap: 3rem;
  text-align: left; /* Centraliza o texto */

  img {
    width: 35px;
    filter: brightness(0) saturate(100%) invert(100%);
  }
  hr {
    // width: 60px;
    height: 2px;
    background-color: #888888;
  }
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 150px;
  a {
    color: inherit;
  }
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const CarrosselButtons = styled.div`
  // position: absolute;
  // top: 50%;
  display: flex;
  // width: 200px;

  justify-content: space-between;
  // transform: translateY(-50%);
  margin-top: 15px;
`;

export const CarrosselButton = styled.button`
  border: none;
  cursor: pointer;
  background-color: transparent; /* Fundo transparente */
`;

export const FloatingButton = styled.button`
  position: absolute;
  bottom: 10px;
  right: 10px;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  background-color: transparent; /* Fundo transparente */
  img {
    border-right: none;
  }
`;

export const SubscribeButtons = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SubscribeButton = styled.div`
  font-family: 'Roboto Regular', sans-serif;
  font-size: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 3px;
  width: fit-content;
  white-space: nowrap;
  padding: 8px 16px;
  font-size: 14px;
  // background-color: ${({ theme }) => theme.background2};
  color: ${({ theme }) => theme.background2};
  @media (max-width: 1000px) {
    width: 200px;
  }
  height: 40px;
  transition: 0.3s;
  background-color: ${({ theme }) => theme.font3};
`;
